import { useMemo } from "react";
import useCallApiUrl from "hook/useCallApiUrl";

const useCallSaleTrend = (filter = {}, trendType = "") => {
    const enable = Object.keys(filter).length > 0;

    const queryParams = useMemo(() => {
        return {
            ...filter,
            trendType,
        };
    }, [filter, trendType]);

    return useCallApiUrl(
        "/api/analytic/sale/trend",
        queryParams,
        enable
    );
};

export default useCallSaleTrend;